export function getContentViewParams() {
  const {
    priceInfo: { price },
    dealNo: mainDealSrl,
    mainOptionNo: optionDealSrl,
  } = TMON.oApp.htStorage.htStaticData.htDealInfo;
  const isAppMode = TMON.view_mode === 'app';
  const contentType = `${TMON.oApp.oUtil.getMainCategoryNo()}`;

  const trackingParams = {
    [isAppMode ? 'mainDealSrl' : 'content_main_id']: `${mainDealSrl}`,
    [isAppMode ? 'optionDealSrl' : 'content_option_id']: `${optionDealSrl}`,
    [isAppMode ? 'contentType' : 'content_type']: `${contentType}`,
    currency: 'KRW',
    price,
  };

  return trackingParams;
}

function getEventName(eventName) {
  const pos = TMON.view_mode === 'app' ? 0 : 1;
  const eventNameMappingList = {
    contentView: ['contentViewTracking', 'content_view'],
    addToCart: ['addToCartTracking', 'add_to_cart'],
  };

  return eventNameMappingList[eventName][pos] || '';
}

const singularCallApp = eventName => param => {
  TMON.app.callApp('tmon_tracking', eventName, JSON.stringify(param), 'AFS');
};

const singularCallWeb = eventName => param => {
  dataLayer.push({
    event: eventName,
    cuid: TMON.memberNo,
    ...param,
  });
};

export function sendSingular(originTrackingParams, eventName) {
  const objectToArray = input => (Array.isArray(input) ? input : [input]);
  const trackingParams = objectToArray(originTrackingParams);

  if (TMON.view_mode === 'app') {
    trackingParams.forEach(singularCallApp(eventName));
  } else {
    if (TMON.sDeployPhase === 'DEV' || !dataLayer) return;
    trackingParams.forEach(singularCallWeb(eventName));
  }
}

export const SINGULAR_CONFIG = {
  eventName: {
    contentView: getEventName('contentView'),
    addToCart: getEventName('addToCart'),
  },
};
